

import React, { useState } from 'react';
function UiUx() {
const [activeAccordion, setActiveAccordion] = useState('collapseOne');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? '' : id);
  };

  return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>UI/UX</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>UI/UX</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img9.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>UI/UX</h3>
                <div className="space20"></div>
                <p>
                  UI/UX designers are responsible for creating the look and feel of a website or application, and they use a variety of software programs to do so. Some of the most popular UI/UX programs include Figma, Adobe XD, Adobe Illustrator, and Photoshop.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Secure & Scalable Architecture</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>E-commerce & CMS Solutions</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Custom Web Application Development</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Responsive & Mobile-Friendly Design</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                  Whether you’re looking for a designer to create a new user interface or improve existing ones, we have a talented professional in-house who can help. One of the most popular tools for UI/UX designers are Figma and Adobe XD. This program is versatile and user-friendly, making it perfect for creating high-quality user interfaces and user experience designs. Additionally, Vector Image is another powerful tool that can be used for UI/UX design. This program allows you to create vector illustrations that can be used in user interfaces and other graphical elements. So if you’re looking for a designer who can help you design stunning user interfaces and user experience designs, look no further than the professionals at Figma or Adobe XD.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img10.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img11.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
  <b>Growing Demand</b> – UI/UX design is becoming increasingly popular and essential.
  </li>
  <li>
    <b>User Impact</b> – Good design directly affects how users feel about a website or app
  </li>
  <li>
    <b>Figma for UI/UX</b> – A powerful, web-based platform for creating designs.
  </li>
  <li>
    <b>Drag-and-Drop Interface</b> – Simplifies the design process for beginners and experts.
  </li>
  <li>
    <b>Prototyping & Testing</b> – Quickly test how designs work in real scenarios.
  </li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default UiUx
